import React from 'react';
import { Link } from "react-router-dom";
import './Workcards.sass';
import { Headline } from '../headline/Headline';
import Card from '../card/Card';

interface WorkProps {
  headline: string;
  subline: string;
  image: string;
  link: string;
  text: string;
  year: string;
  width?: string;
}

function Work(props: WorkProps) {
  return (
    <Link className="workcards" to={props.link}>
      <Card>
        <img src={props.image} alt={props.headline} />
      </Card>
      <div className="workcards__content">
        <div>
          <Headline level="h3">{props.headline}</Headline>
          <p>{props.subline}</p>
        </div>
        <div>
          <p>{props.text}</p>
        </div>
        <div>
          <p className="year">{props.year}</p>
        </div>
      </div>
    </Link>
  );
}

export default Work;
